module.exports = __webpack_public_path__ + "static/media/shoe.f57ff750.svg";